<ng-container [formGroup]="controller.filterForm">
	<div class="flex-none w-6"></div>
	<div
		*ngIf="controller.showTypeColumn$ | async"
		class="md:flex-1 grid grid-cols-3 md:grid-cols-1 gap-6"
	>
		<div class="md:hidden whitespace-pre-line">
			{{ controller.i18n + '.types.text' | translate }}
		</div>
		<div class="col-span-2">
			<p-multiSelect
				[options]="controller.documentTypeOptions$ | async"
				class="w-full"
				appendTo="body"
				formControlName="types"
				styleClass="w-full"
			></p-multiSelect>
		</div>
	</div>
	<div class="md:flex-1 grid grid-cols-3 md:grid-cols-1 gap-6">
		<div class="md:hidden whitespace-pre-line">
			{{ controller.i18n + '.name.text' | translate }}
		</div>
		<span class="p-input-icon-right w-full col-span-2">
			<i class="fak fa-str-filter"></i>
			<input class="w-full" formControlName="name" pInputText type="text" />
		</span>
	</div>
	<div
		*ngIf="controller.showSectionColumn$ | async"
		class="md:flex-1 grid grid-cols-3 md:grid-cols-1 gap-6"
	>
		<div class="md:hidden whitespace-pre-line">
			{{ controller.i18n + '.sections.text' | translate }}
		</div>
		<div class="col-span-2">
			<p-multiSelect
				[group]="true"
				[options]="controller.sectionOptions$ | async"
				class="w-full"
				appendTo="body"
				formControlName="sectionsId"
				styleClass="w-full"
			></p-multiSelect>
		</div>
	</div>
	<div class="md:flex-1 grid grid-cols-3 md:grid-cols-1 gap-6">
		<div class="md:hidden whitespace-pre-line">
			{{ controller.i18n + '.date.text' | translate }}
		</div>
		<div class="col-span-2">
			<div class="flex items-center space-x-1">
				<div class="p-inputgroup">
					<p-calendar
						[showClear]="true"
						class="w-full"
						appendTo="body"
						formControlName="dates"
						selectionMode="range"
						styleClass="w-full"
					></p-calendar>
					<span class="p-inputgroup-addon">
						<i class="fak fa-str-calendar"></i>
					</span>
				</div>
				<p-button
					[icon]="controller.dateSortCssIconClass$ | async"
					(onClick)="onDateSortClick()"
					styleClass="p-button-grey border-none text-sm"
				></p-button>
			</div>
		</div>
	</div>
	<div class="md:flex-none md:w-16"></div>
</ng-container>
